import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickNavigationCards = ({ cards }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {cards?.map((card) => (
        <Link
          key={card?.id}
          to={card?.path}
          className="bg-card border border-border rounded-lg p-4 md:p-6 hover:shadow-lg transition-all duration-250 group"
          style={{ '--hover-border-color': 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.5)))' }}
          onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 0.5)))'}
          onMouseLeave={(e) => e.currentTarget.style.borderColor = ''}
        >
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 transition-colors duration-250">
              <Icon name={card?.icon} size={24} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-semibold text-foreground mb-1 transition-colors duration-250">
                {card?.title}
              </h3>
              <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                {card?.description}
              </p>
              {card?.count && (
                <div className="mt-2 inline-flex items-center text-xs font-medium">
                  <span className="mr-1 text-primary font-semibold">{card?.count}</span>
                  <span className="text-muted-foreground">items available</span>
                </div>
              )}
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default QuickNavigationCards;